module.exports = __webpack_public_path__ + "img/img2m.08c5facc.jpg";